import { render, staticRenderFns } from "./PerfilRotaAssociacaoPage.vue?vue&type=template&id=214fec11"
import script from "./PerfilRotaAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./PerfilRotaAssociacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports